import { render } from "./EmergencyContactLandingPage.vue?vue&type=template&id=299060ce&scoped=true"
import script from "./EmergencyContactLandingPage.vue?vue&type=script&lang=js"
export * from "./EmergencyContactLandingPage.vue?vue&type=script&lang=js"

import "./EmergencyContactLandingPage.vue?vue&type=style&index=0&id=299060ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299060ce"]])

export default __exports__